var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 8c1.934 0 3.5-1.566 3.5-3.5S12.934 1 11 1a3.499 3.499 0 00-3.5 3.5C7.5 6.434 9.066 8 11 8zm0 1.75c-2.336 0-7 1.172-7 3.5V15h14v-1.75c0-2.328-4.664-3.5-7-3.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.25c1.23 0 3.044.305 4.563.913.759.304 1.476.697 2.011 1.19.539.498.926 1.132.926 1.897v2.25H.5v-2.25c0-.765.387-1.4.926-1.896.535-.494 1.252-.887 2.011-1.19C4.957 9.553 6.77 9.25 8 9.25zM8 .5c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4z",
    stroke: "var(--background-color, white)"
  })));
}
export default SvgMultiUser;